// Utils functions
export function shortID(object_id) {
  return object_id ? String(object_id).slice(-5, object_id.length).toUpperCase() : null
}

export function switchKey(key) {
  switch (key) {
    case 'users':
      return 'system.users'
    default:
      return key
  }
}
